import script from "./FriendsEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./FriendsEvents.vue?vue&type=script&setup=true&lang=js"

import "./FriendsEvents.vue?vue&type=style&index=0&id=495d75c8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-495d75c8"]])

export default __exports__